module.exports = __webpack_public_path__ + "static/media/2d4831eb.jpg";